<div [ngSwitch]="invalidPRStateForProceeding" class="page-body">
  <div *ngSwitchCase="true" class="error-wrapper">
    <div class="contents-container">
      <h3 class="general-error-text">
        Die Zahlungsaufforderung wurde annuliert.
      </h3>
      <p class="info-text">
        Bitte versuchen Sie es erneut. Kontaktieren Sie uns, wenn das Problem
        weiterhin besteht.
      </p>
    </div>
  </div>

  <div *ngSwitchDefault class="error-wrapper">
    <div class="contents-container">
      <p class="heading">{{ state.interruptionDetails?.heading }}</p>
      <p class="info-text">{{ state.interruptionDetails?.message }}</p>

      <div class="button-wrapper">
        <zaver-secondary-button-outlined
          *ngIf="state.interruptionDetails.ctaLabel"
          class="button-width"
          (click)="handleCtaClick()"
          [text]="state.interruptionDetails.ctaLabel"
          [rounded]="true"
          [disabled]="navigationInProgress"
        ></zaver-secondary-button-outlined>
      </div>
      <zaver-button-link
        class="button-link"
        *ngIf="state.interruptionDetails.linkLabel"
        (click)="handleLinkClick()"
        [text]="state.interruptionDetails.linkLabel"
        [disabled]="navigationInProgress"
      ></zaver-button-link>
    </div>
  </div>
</div>
